import { FC, useEffect, useState } from 'react';
import './index.scss';
import { BrandOnboardTitle } from '../../components/BrandOnboard/BrandOnboardTitle/BrandOnboardTitle';
import { BrandOnboardContent } from '../../components/BrandOnboard/BrandOnboardContent/BrandOnboardContent';
import { BrandOnboardFooter } from '../../components/BrandOnboard/BrandOnboardFooter/BrandOnboardFooter';
import { isCurrentUserAnonymous } from '../../helpers/authenticationHelper';
import { IBrandOnboardContent } from '../../common/view-model';
import { FirstTimeExpoComponent } from '../../components/BrandOnboard/FirstTimeExpo/FirstTimeExpoComponent';
import { NeedToMakeChangesComponent } from '../../components/BrandOnboard/NeedToMakeChanges/NeedToMakeChangesComponent';
import { BeaconOnlyBrandComponent } from '../../components/BrandOnboard/BeaconOnlyBrand/BeaconOnlyBrandComponent';
import { BrandOnboardPageModel as model } from './model';
import { AppActions } from '../../redux/AppActions';
import { useAppDispatch } from '../../redux/store';
interface BrandOnboardPageComponentProps {
	toggleState?: string | number;
}
const BrandOnboardPageComponent: FC<BrandOnboardPageComponentProps> = ({ toggleState }) => {
	const dispatch = useAppDispatch();
	const brandContentElements: IBrandOnboardContent[] = [
		{
			...model.firstTimeComponentProps,
			content: <FirstTimeExpoComponent />
		},
		{
			...model.needChangesComponentProps,
			content: <NeedToMakeChangesComponent />
		},
		{
			...model.beaconOnlyComponentProps,
			content: <BeaconOnlyBrandComponent />
		}
	];
	const featureProductId = '64d192f6ae6f5265ed44dddf';
	const featureBrandId = '1687307593_649245490140b6.73924905';
	const [contentElements, setContentElements] =
		useState<IBrandOnboardContent[]>(brandContentElements);
	const handleSetActive = (id: string) => {
		const validateShouldCloseAll = contentElements.find(
			element => element.id === id && element.active
		);
		const newElements = contentElements.map(element => {
			element.active = element.id === id && !validateShouldCloseAll ? !element.active : false;
			return element;
		});
		setContentElements(newElements);
	};

	const setIsStandAloneLayout = (isProfileLayout: boolean) =>
		dispatch(AppActions.setProfileLayout(isProfileLayout));

	useEffect(() => {
		setContentElements(
			brandContentElements.map(element => ({
				...element,
				active: false
			}))
		);
	}, [toggleState]);
	useEffect(() => {
		if (isCurrentUserAnonymous()) {
			setIsStandAloneLayout(true);
		}
		return () => {
			setIsStandAloneLayout(false);
		};
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<section
			className={`brand-onboard-page-container new ${
				isCurrentUserAnonymous() ? 'public-brand-onboard-page' : ''
			}`}
		>
			<div className={'new-title-container'}>
				<BrandOnboardTitle
					featuredProductLink={`${window.location.origin}/detail/${featureProductId}`}
					featuredBrandLink={`${window.location.origin}/brand/${featureBrandId}`}
				/>
			</div>
			<div className={'new-content-container'}>
				<BrandOnboardContent elements={contentElements} handelSetActive={handleSetActive} />
			</div>
			<div className={'new-footer-container'}>
				<BrandOnboardFooter />
			</div>
		</section>
	);
};

export default BrandOnboardPageComponent;
